import { useSetAtom as s, useAtomValue as o } from "jotai/index";
import { showSalesTermsAtom as e, showTermsAndConditionsAtom as n, salesTermsAndConditionsAtom as t } from "./index59.mjs";
const i = () => ({
  setShowSalesTerms: s(e),
  isShowSalesTerms: o(e)
}), d = () => ({
  setShowTermsAndConditions: s(n),
  isShowTermsAndConditions: o(n)
}), A = () => ({
  setSalesTermsAndConditions: s(t),
  salesTermsAndConditions: o(t)
});
export {
  A as useSalesTermsAndConditions,
  i as useSalesTermsShow,
  d as useTermsAndConditionsShow
};
